import { render, staticRenderFns } from "./PersonRoleEdit.vue?vue&type=template&id=5f110932"
import script from "./PersonRoleEdit.vue?vue&type=script&lang=js"
export * from "./PersonRoleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports